module.exports = __webpack_public_path__ + "static/LogoDH-16661df59e06eacfb7accbfa293e15f6.svg";